import { DOWNLOAD_VENDOR_DOCUMENTS } from '../useVendorDocumentsService';
import { Filters, FiltersLayout, DropDownFilter } from 'framework/list';
import { FullDateField, EnumField } from 'framework/ui/field';
import UploadVendorDocButton from '../createupdate/UploadVendorDocButton';
import { DocumentsListWrapper } from 'framework/documentStorage';
import { EnumDropdown } from 'framework/form';
import { ALL_VENDOR_DOCUMENT_TYPES_VALUES } from '../constants';
import VendorDocumentActions from '../shared/buttons/VendorDocumentActions';
import { useDocumentStorageContext } from 'framework/documentStorage';
import { DownloadFileLinkField } from 'domain/shared/artifact/field';

const VendorDocumentsList = () => {
  const { searchDocuments } = useDocumentStorageContext();

  const filters = (
    <Filters>
      <FiltersLayout>
        <DropDownFilter source="fileType" label="Type">
          <EnumDropdown source="fileType" label="Type" options={ALL_VENDOR_DOCUMENT_TYPES_VALUES} />
        </DropDownFilter>
      </FiltersLayout>
    </Filters>
  );

  return (
    <DocumentsListWrapper
      getDataMethod={searchDocuments}
      filters={filters}
      actions={[<UploadVendorDocButton />]}
      itemButtons={[<VendorDocumentActions />]}
    >
      <EnumField label="Type" source="metadata.fileType" options={ALL_VENDOR_DOCUMENT_TYPES_VALUES} width="20%" />
      <DownloadFileLinkField label="File" permission={DOWNLOAD_VENDOR_DOCUMENTS} width="40%" />
      <FullDateField label="Created at" source="metadata.createdAt" />
    </DocumentsListWrapper>
  );
};

export default VendorDocumentsList;
